<template>
  <div class="project-overview">
      <div class="el-row ">
          <div class="title">
            <img class="title-img" src="@/assets/image/index/公司@2x.png" alt="">
            公司管理层级
          </div>
          <div class="content">{{detailData.managementLevel}}</div>
      </div>
      <div class="el-row  mt-16">
          <div class="title">
            <img class="title-img" src="@/assets/image/index/项目@2x.png" alt="">
            项目名称
          </div>
          <div class="content">{{detailData.name}}</div>
      </div>
      <div class="el-row  mt-16">
          <div class="title">
            <img class="title-img" src="@/assets/image/index/项目@2x.png" alt="">
            项目简称
          </div>
          <div class="content">{{detailData.shortName}}</div>
      </div>
      <div class="el-row  mt-16">
        <div class="el-col-12">
          <div class="title">
            <img class="title-img" src="@/assets/image/index/工程备份@2x.png" alt="">
            工程类别
          </div>
          <div class="content">{{detailData.projectCategory}}</div>
        </div>
        <div class="el-col-12">
          <div class="title">
            <img class="title-img" src="@/assets/image/index/等级备份@2x.png" alt="">
            项目等级
          </div>
          <div class="content">{{detailData.level}}</div>
        </div>
      </div>
      <div class="el-row  mt-16">
        <div class="el-col-12">
          <div class="title">
            <img class="title-img" src="@/assets/image/index/工程备份@2x.png" alt="">
            项目状态
          </div>
          <div class="content">{{detailData.status}}</div>
        </div>
        <div class="el-col-12">
          <div class="title">
            <img class="title-img" src="@/assets/image/index/等级备份@2x.png" alt="">
            施工阶段
          </div>
          <div class="content">{{detailData.constructionStage}}</div>
        </div>
      </div>
      <div class="el-row  mt-16">
        <div class="el-col-12">
          <div class="title">
            <img class="title-img" src="@/assets/image/index/合同价格@2x.png" alt="">
            合同价格
          </div>
          <div class="content">{{detailData.contractAmount}}万元</div>
        </div>
        <div class="el-col-12">
          <div class="title">
            <img class="title-img" src="@/assets/image/index/面积@2x.png" alt="">
            建筑面积
          </div>
          <div class="content">{{detailData.buildingArea}}㎡</div>
        </div>
      </div>
      <div class="el-row  mt-16">
        <div class="el-col-12">
          <div class="title">
            <img class="title-img" src="@/assets/image/index/竣工日期@2x.png" alt="">
            合同开工日期
          </div>
          <div class="content">{{detailData.contractStartDate}}</div>
        </div>
        <div class="el-col-12">
          <div class="title">
            <img class="title-img" src="@/assets/image/index/施工阶段@2x.png" alt="">
            合同竣工日期
          </div>
          <div class="content">{{detailData.contractCompletionDate}}</div>
        </div>
      </div>
      <div class="el-row  mt-16">
        <div class="el-col-12">
          <div class="title">
            <img class="title-img" src="@/assets/image/index/竣工日期@2x.png" alt="">
            实际开工日期
          </div>
          <div class="content">{{detailData.actualStartDate}}</div>
        </div>
        <div class="el-col-12">
          <div class="title">
            <img class="title-img" src="@/assets/image/index/施工阶段@2x.png" alt="">
            实际竣工日期
          </div>
          <div class="content">{{detailData.actualCompletionDate}}</div>
        </div>
      </div>
      <div class="el-row  mt-16">
        <div class="el-col-12">
          <div class="title">
            <img class="title-img" src="@/assets/image/index/竣工日期@2x.png" alt="">
            合同工期
          </div>
          <div class="content">{{detailData.durationDay}}</div>
        </div>
        <div class="el-col-12">
          <div class="title">
            <img class="title-img" src="@/assets/image/index/行政区域@2x.png" alt="">
            行政区划
          </div>
          <div class="content">{{detailData.administrationLocation}}</div>
        </div>
      </div>
      <div class="el-row  mt-16">
          <div class="title">
            <img class="title-img" src="@/assets/image/index/行政区域@2x.png" alt="">
            详细地址
          </div>
          <div class="content">{{detailData.address}}</div>
      </div>
  </div>
</template>
<script >
import { getProject } from '@/utils/indexApi';
export default{
  data(){
    return{
      detailData:{}
    }
  },
  methods:{
    getData(){
      getProject().then(res=>{
        this.detailData = res.data
      })
    }
  },
  created(){
    this.getData()
  }
}
</script>
<style  lang="scss" scoped>
.mt-16{
  margin-top: 16px; 
  
}
.el-row{
  padding-bottom: 17px;
  border-bottom: 1px solid rgba(187,198,214,0.3);
  .title{
    display: flex;
    align-items: center;
    font-family: AlibabaPuHuiTi_2_65_Medium;
    font-size: 14px;
    color: #BBC6D6;
    line-height: 20px;
    text-shadow: 0px 6px 6px rgba(0,0,0,0.3);
    text-align: justify;
    font-style: normal;
    text-transform: none;
    
    .title-img{
      width: 17px;
      height: 17px;
      margin-right: 3px;
    }
  }
  .content{
    margin-top: 7px;
    font-family: AlibabaPuHuiTi_2_65_Medium;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 22px;
    text-shadow: 0px 6px 6px rgba(0,0,0,0.3);
    text-align: justify;
    font-style: normal;
    text-transform: none;
  }
}
</style>